module.exports = "/assets/1df4ef8ad2e6b1ed7a9d3ee7dcbc83d8.png";